import { render, staticRenderFns } from "./CommissionStandard.vue?vue&type=template&id=365a56b8&scoped=true&"
import script from "./CommissionStandard.vue?vue&type=script&lang=js&"
export * from "./CommissionStandard.vue?vue&type=script&lang=js&"
import style0 from "./CommissionStandard.vue?vue&type=style&index=0&id=365a56b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a56b8",
  null
  
)

export default component.exports